module.exports = __webpack_public_path__ + "img/DinosaurWaterWorld.067673fa.jpg";